import styled from "@emotion/styled";
import React from "react";
import { useRecoilState } from "recoil";
import { updateUser } from "../../api/User";
import { ActiveEmailAtom } from "../../atoms/ActiveEmailAtom";
import { UserAtom } from "../../atoms/UserAtom";
import { ITheme } from "../../types/UserTypes";
import { themes } from "../../utils/constants";

const AbsoluteDiv = styled.div`
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 240px;
  overflow-y: auto;
  height: 85px;
  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 4px;
  box-shadow: 0px 3px 15px #00000033;
  text-align: left;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  padding-top: 10px;
`;

const Title = styled.div`
  padding-left: 20px;
  padding-top: 5px;
  color: #2f2f2f;
  font-size: 14px;
  margin-bottom: 5px;
`;

const ColorThemeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
`;

const ColorItem = styled.div<{
  color: string;
  border: string;
  active: boolean;
}>`
  background-color: ${(props) => props.color};
  border: 1px solid ${(props) => props.border};
  box-shadow: ${(props) =>
    props.active ? "0px 0px 0px 1px white, 0px 0px 0px 3px #fb972e" : "none"};
  border-radius: 100%;
  height: 30px;
  width: 30px;
  cursor: pointer;
`;

export default function ThemePicker(): JSX.Element {
  const [activeEmail, setActiveEmail] = useRecoilState(ActiveEmailAtom);

  const [user, setUser] = useRecoilState(UserAtom);

  function handleChangeTheme(colors: ITheme) {
    if (!colors) return;

    setActiveEmail((oldActiveEmail) => {
      return {
        ...oldActiveEmail,
        fontColor: colors.textColor,
        backgroundColor: colors.color,
        placeholderColor: colors.placeholderColor,
        titleColor: colors.titleColor,
        titlePlaceholderColor: colors.titlePlaceholderColor,
      };
    });
    const newUser = {
      emailOptions: {
        ...user.emailOptions,
        theme: colors,
      },
    };
    updateUser(newUser);
    setUser({ ...user, ...newUser });
  }

  return (
    <AbsoluteDiv className="theme-container">
      <Title>Display Theme</Title>
      <ColorThemeContainer>
        {themes.map((colorItem) => (
          <ColorItem
            onClick={() => handleChangeTheme(colorItem)}
            color={colorItem.color}
            active={activeEmail.backgroundColor === colorItem.color}
            border={colorItem.border}
          />
        ))}
      </ColorThemeContainer>
    </AbsoluteDiv>
  );
}
